{
  "metadata": {
    "anno_riferimento": 2026,
    "data_ultimo_aggiornamento": "2026-07-24",
    "fonte": "Circolare INPS n. 8/2026 (Gestione Separata); Circolare INPS n. 14/2026 (Artigiani/Commercianti); Fondazione ENASARCO 2026; siti ufficiali delle casse professionali (Cassa Forense, Inarcassa, ENPAM, ENPACL, CNPADC, CNPR, CIPAG, ENPAP, ENPAV, EPAP, EPPI, ENPAPI), valori 2026"
  },
  "gestioni_previdenziali": [
    {
      "id": "INPS_GS",
      "label": "INPS Gestione Separata (Freelance)",
      "gruppo": "INPS",
      "tipo": "PERCENTUALE_PURA",
      "aliquota": 26.07,
      "costo_fisso": 0,
      "massimale_reddito": 122295,
      "note_massimale": "Massimale annuo 2026 (art. 2 c. 18 L. 335/1995): oltre 122.295 € di reddito non si versano ulteriori contributi. Fonte: Circolare INPS n. 8/2026."
    },
    {
      "id": "INPS_ART",
      "label": "INPS Artigiani",
      "gruppo": "INPS",
      "tipo": "MISTO_CON_MINIMALE",
      "aliquota_eccedenza": 24,
      "minimale_reddito": 18808,
      "costo_fisso_annuo": 4521.36,
      "riduzione_forfettario_disponibile": true,
      "soglia_solidarieta": 56224,
      "massimale_reddito": 122295,
      "massimale_reddito_ante1996": 93707,
      "note_massimale": "Massimale annuo 2026: 122.295 € senza anzianita' contributiva al 31/12/1995, 93.707 € con anzianita'. Non frazionabile a mese. Fonte: Circolare INPS n. 14/2026."
    },
    {
      "id": "INPS_COM",
      "label": "INPS Commercianti",
      "gruppo": "INPS",
      "tipo": "MISTO_CON_MINIMALE",
      "aliquota_eccedenza": 24.48,
      "minimale_reddito": 18808,
      "costo_fisso_annuo": 4611.64,
      "riduzione_forfettario_disponibile": true,
      "soglia_solidarieta": 56224,
      "massimale_reddito": 122295,
      "massimale_reddito_ante1996": 93707,
      "note_massimale": "Massimale annuo 2026: 122.295 € senza anzianita' contributiva al 31/12/1995, 93.707 € con anzianita'. Non frazionabile a mese. Fonte: Circolare INPS n. 14/2026."
    },
    {
      "id": "ENASARCO_MONO",
      "label": "ENASARCO - Agente monomandatario",
      "gruppo": "ENASARCO",
      "tipo": "ENASARCO",
      "aliquota_agente": 8.5,
      "minimale_annuo_agente": 513,
      "massimale_provvigioni": 45717,
      "mandanti_multipli": false,
      "note": "Quota a carico agente: 8,5%. Il mandante versa anche la sua quota (8,5%). Massimale provvigionale annuo: 45.717€. Minimale annuo quota agente: 513€. Fonte: ENASARCO 2026."
    },
    {
      "id": "ENASARCO_PLURI",
      "label": "ENASARCO - Agente plurimandatario",
      "gruppo": "ENASARCO",
      "tipo": "ENASARCO",
      "aliquota_agente": 8.5,
      "minimale_annuo_agente": 257.5,
      "massimale_provvigioni": null,
      "massimale_provvigioni_per_mandante": 30478,
      "mandanti_multipli": true,
      "note": "Quota a carico agente: 8,5%. Massimale e minimale si applicano per rapporto di agenzia: 30.478€ di provvigioni e 257,50€ di minimale per ogni mandante. Fonte: ENASARCO 2026."
    },
    {
      "id": "CASSA_FORENSE",
      "label": "Cassa Forense (Avvocati)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 17,
      "note": "Soggettivo 17% fino a 131.800 € e 3% oltre; integrativo 4% (in rivalsa al cliente). Minimi 2026: 2.790 € soggettivo, 355 € integrativo (dimezzati per under 35 nei primi 6 anni). Maternità 2026 non ancora deliberata: usato il valore 2025 (57,65 €). Fonte: Cassa Forense, tabella contributi minimi 2026.",
      "aliquota_soggettivo": 17,
      "minimo_soggettivo": 2790,
      "limite_reddito_soggettivo": 131800,
      "aliquota_soggettivo_oltre": 3,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 355,
      "contributo_maternita": 57.65
    },
    {
      "id": "INARCASSA",
      "label": "Inarcassa (Architetti e Ingegneri)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 14.5,
      "aliquota_soggettivo": 14.5,
      "minimo_soggettivo": 2785,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 850,
      "contributo_maternita": 91,
      "limite_reddito_soggettivo": 145550,
      "note": "Soggettivo 14,5% fino a 145.550 €; integrativo 4% (in rivalsa al cliente). Minimi 2026: 2.785 € soggettivo, 850 € integrativo. Maternità 2026 fissata in via provvisoria al valore 2025 (91 €). Fonte: Inarcassa."
    },
    {
      "id": "ENPAM",
      "label": "ENPAM (Medici)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "ENPAM",
      "aliquota": 19.5,
      "note": "Quota A fissa per fascia d eta (2026: 304,73 € fino a 30 anni, 591,47 € da 30 a 35, 1.109,92 € da 35 a 40, 2.049,83 € oltre i 40) piu maternita 84,26 €. Quota B 19,5% sul reddito eccedente la quota gia coperta dalla Quota A (5.446,77 € sotto i 40 anni, 10.059,28 € dai 40), 1% oltre 150.000 €. Fonte: Fondazione ENPAM.",
      "quota_a": {
        "studenti": 152.37,
        "under30": 304.73,
        "da30a35": 591.47,
        "da35a40": 1109.92,
        "over40": 2049.83
      },
      "franchigia_quota_b": {
        "under40": 5446.77,
        "over40": 10059.28
      },
      "aliquota_quota_b": 19.5,
      "limite_quota_b": 150000,
      "aliquota_quota_b_oltre": 1,
      "contributo_maternita": 84.26
    },
    {
      "id": "ENPACL",
      "label": "ENPACL (Consulenti del Lavoro)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 12,
      "note": "Soggettivo 12% fino a 122.016 €; integrativo 4% (in rivalsa al cliente). Minimi 2026: 2.620 € soggettivo (1.310 € ridotto), 380 € integrativo. Fonte: ENPACL.",
      "aliquota_soggettivo": 12,
      "minimo_soggettivo": 2620,
      "limite_reddito_soggettivo": 122016,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 380,
      "contributo_maternita": 52.98
    },
    {
      "id": "CNPADC",
      "label": "CNPADC (Dottori Commercialisti)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 12,
      "note": "Soggettivo dal 12% al 100% (qui si usa l aliquota minima del 12%); integrativo 4% (in rivalsa al cliente). Minimi 2026: 3.180 € soggettivo, 954 € integrativo. Fonte: CNPADC.",
      "aliquota_soggettivo": 12,
      "minimo_soggettivo": 3180,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 954,
      "contributo_maternita": 0
    },
    {
      "id": "CNPR",
      "label": "CNPR (Ragionieri)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 15,
      "note": "Soggettivo 15% (minimo 3.771,10 €) più supplementare 0,75% (minimo 636 €); integrativo 4% (in rivalsa al cliente, minimo 936,06 €). Maternità 12 €. Fonte: CNPR.",
      "aliquota_soggettivo": 15,
      "minimo_soggettivo": 3771.1,
      "aliquota_soggettivo_supplementare": 0.75,
      "minimo_soggettivo_supplementare": 636,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 936.06,
      "contributo_maternita": 12
    },
    {
      "id": "CIPAG",
      "label": "CIPAG (Geometri)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 20,
      "note": "Soggettivo 20% fino a 183.550 €; integrativo 5% (in rivalsa al cliente). Minimi 2026: 4.240 € soggettivo, 1.955 € integrativo, 9 € maternità. Fonte: CIPAG, tabella contributi minimi 2026.",
      "aliquota_soggettivo": 20,
      "minimo_soggettivo": 4240,
      "limite_reddito_soggettivo": 183550,
      "aliquota_integrativo": 5,
      "minimo_integrativo": 1955,
      "contributo_maternita": 9
    },
    {
      "id": "ENPAP",
      "label": "ENPAP (Psicologi)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 10,
      "note": "Soggettivo 10% (elevabile fino al 30%), minimo 856 €; integrativo 2% (in rivalsa al cliente), minimo 66 €; maternità 130 €. Fonte: ENPAP.",
      "aliquota_soggettivo": 10,
      "minimo_soggettivo": 856,
      "aliquota_integrativo": 2,
      "minimo_integrativo": 66,
      "contributo_maternita": 130
    },
    {
      "id": "ENPAV",
      "label": "ENPAV (Veterinari)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 18.5,
      "note": "Soggettivo 18,5% fino a 112.100 € e 3% oltre (sale di 0,5 punti l anno fino al 22% nel 2033); integrativo 2% (in rivalsa al cliente). Minimi 2026: 3.542,85 € soggettivo, 574,50 € integrativo, 100 € maternità, 267,50 € solidarietà. Fonte: ENPAV.",
      "aliquota_soggettivo": 18.5,
      "minimo_soggettivo": 3542.85,
      "limite_reddito_soggettivo": 112100,
      "aliquota_soggettivo_oltre": 3,
      "aliquota_integrativo": 2,
      "minimo_integrativo": 574.5,
      "contributo_maternita": 100,
      "minimo_solidarieta": 267.5
    },
    {
      "id": "ENPAB",
      "label": "ENPAB (Biologi)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "PERCENTUALE_PURA",
      "aliquota": 15,
      "minimi_non_modellati": true,
      "note": "Soggettivo 15% del reddito netto (elevabile fino al 36%), integrativo 4% del fatturato, maternita 136 €. I contributi minimi 2026 non sono inclusi nella stima: il sito ENPAB non era raggiungibile alla data di aggiornamento. Fonte: ENPAB, regolamento di disciplina delle funzioni di previdenza."
    },
    {
      "id": "EPAP",
      "label": "EPAP (Geologi, Chimici, Attuari)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 10,
      "note": "Soggettivo 10% fino a 122.295 €; integrativo 4% (in rivalsa al cliente); solidarietà 0,2% (minimo 15 €). Minimi 2026: 739 € soggettivo, 295 € integrativo. Maternità 2026 in attesa di approvazione ministeriale. Fonte: EPAP.",
      "aliquota_soggettivo": 10,
      "minimo_soggettivo": 739,
      "limite_reddito_soggettivo": 122295,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 295,
      "contributo_maternita": 0,
      "aliquota_solidarieta": 0.2,
      "minimo_solidarieta": 15
    },
    {
      "id": "EPPI",
      "label": "EPPI (Periti Industriali)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 18,
      "note": "Soggettivo 18% fino al massimale; integrativo 5% (in rivalsa al cliente). Minimi: 2.359 € soggettivo, 655 € integrativo. Maternità 2026 non ancora deliberata. Il massimale indicato dalla cassa (120.607 €) coincide con quello INPS 2025: verificare l aggiornamento 2026. Fonte: EPPI.",
      "aliquota_soggettivo": 18,
      "minimo_soggettivo": 2359,
      "limite_reddito_soggettivo": 120607,
      "aliquota_integrativo": 5,
      "minimo_integrativo": 655,
      "contributo_maternita": 0
    },
    {
      "id": "ENPAPI",
      "label": "ENPAPI (Infermieri)",
      "gruppo": "CASSE_PROFESSIONALI",
      "tipo": "CASSA_CON_MINIMI",
      "aliquota": 16,
      "note": "Soggettivo 16% (minimo 1.600 €); integrativo 4% (in rivalsa al cliente, minimo 150 €). Maternità determinata annualmente dal CdA. La pagina ufficiale non riporta l anno: verificare l aggiornamento 2026. Fonte: ENPAPI.",
      "aliquota_soggettivo": 16,
      "minimo_soggettivo": 1600,
      "aliquota_integrativo": 4,
      "minimo_integrativo": 150,
      "contributo_maternita": 0
    }
  ]
}
